module.exports = __webpack_public_path__ + "static/media/pickle_mar_680_gr.50065cbf.png";